export const FUEL_NETWORK_URL = 'http://127.0.0.1:4000/graphql';
